import React, { useEffect, useRef } from "react";
import Box from "@mui/material/Box";

import { makeStyles } from "@mui/styles";
// import { createTheme } from "@mui/material/styles";
import APIURLConstants from "../../config/config";
import ApiHelper from "../../utillity/ApiHelper";
import {
	setSocialLoginState,
	useSocialLoginState,
} from "../../hookState/SocialLoginState";
import { setSiteState } from "../../hookState/SiteState";
import Helper from "../../utillity/helper";
import { Hero } from "../../components/Hero";
import Header from "../../components/Header/Header";
import { Service } from "../../components/Service";
import { WhyUs } from "../../components/WhyUs";
import { Pricing } from "../../components/Pricing";
import { Faq } from "../../components/Faq";
import { NewBlog } from "../../components/NewBlog";
import { NewFooter } from "../../components/NewFooter";
import { useHeaderState } from "../../hookState/HeaderState";
import { useNavigate } from "react-router-dom";

const Home = () => {
	const loginOptionName = Helper.getStorage("loginOption");
	const headerState = useHeaderState();
	const navigate = useNavigate();

	if (loginOptionName) {
		setSocialLoginState(loginOptionName);
	}
	const loginOption = useSocialLoginState();

	// console.log(loginOption.get());

	const search = window.location.search;
	const params = new URLSearchParams(search);
	// const token_id = params.get("code");
	// console.log("token_id", token_id);
	// const data = {
	// 	token: token_id,
	// 	provider: loginOption.get() && loginOption.get().name,
	// };

	// useEffect(() => {
	// 	if (token_id) {
	// 		ApiHelper.post(APIURLConstants.GOOGLE_CALLBACK, data)
	// 			.then((res) => {
	// 				console.log(res);
	// 				setSiteState(res.data.result);
	// 			})
	// 			.catch((error) => {
	// 				console.log(error);
	// 			});
	// 	}
	// }, [token_id]);
	const ref = useRef("Home");
	const ref1 = useRef("Service");
	const ref2 = useRef("Whyus");
	const ref3 = useRef("Pricing");
	const ref4 = useRef("Faq");
	const ref5 = useRef("Blog");

	const goToViolation = (id) => {
		if (id === "Blog") {
			window.scrollTo({
				top: ref5.current.offsetTop,
				behavior: "smooth",
			});
		}
		if (id === "Faq") {
			window.scrollTo({
				top: ref4.current.offsetTop,
				behavior: "smooth",
			});
		}
		if (id === "Pricing") {
			window.scrollTo({
				top: ref3.current.offsetTop,
				behavior: "smooth",
			});
		}
		if (id === "Whyus") {
			window.scrollTo({
				top: ref2.current.offsetTop,
				behavior: "smooth",
			});
		}
		if (id === "Service") {
			window.scrollTo({
				top: ref1.current.offsetTop,
				behavior: "smooth",
			});
		}
		if (id === "Home") {
			window.scrollTo({
				top: ref.current.offsetTop,
				behavior: "smooth",
			});
		}
	};
	React.useEffect(() => {
		if (headerState.get().element) {
			navigate("/");
			goToViolation(headerState.get().element);
		}
	}, [headerState.get().element]);
	return (
		<>
			<Box
				sx={{
					width: "100%",
					display: "flex",
					flexDirection: { xs: "column", md: "column" },
					//
					borderRadius: 8,
					gap: { xs: 6, md: 4 },
				}}
				ref={ref}
			>
				<Box
					sx={{
						background: "linear-gradient(to right bottom, #1EB2FF, #156FC6)",
						height: { xs: "750px", md: "800px" },
						// mt: 3,
						mx: 3,
						borderRadius: 8,
					}}
				>
					<Box sx={{ m: "0px 14px 0px 14px" }}>
						<Hero />
					</Box>
				</Box>
				<Box
					display={"flex"}
					justifyContent={"center"}
					ref={ref1}
					mt={{ xs: 4, md: 1 }}
				>
					<Service />
				</Box>
				<Box display={"flex"} justifyContent={"center"} ref={ref2}>
					<WhyUs id={"whyus"} />
				</Box>
				<Box display={"flex"} justifyContent={"center"} ref={ref3}>
					<Pricing id={"pricing"} />
				</Box>
				<Box display={"flex"} justifyContent={"center"} ref={ref4}>
					<Faq id={"faq"} />
				</Box>
				<Box display={"flex"} justifyContent={"center"} ref={ref5}>
					<NewBlog id={"blog"} />
				</Box>

				{/* <NewFooter id={"footer"} /> */}
			</Box>
		</>
	);
};

export default Home;
